// Lines carry no origin/destination fields today: show the route only when both are known,
// otherwise the line name (e.g. "POS-BUE") already names it.
export function formatLineaLabel(linea = {}) {
  const route = linea.origen && linea.destino ? `${linea.origen} → ${linea.destino}` : linea.nombre;
  return [linea.codigo, route].filter(Boolean).join(' - ');
}
